/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useMemo } from 'react';

import {
  Wrapper,
  Container,
  Line,
  Title,
  BreadCrumb,
  Back,
  InfoContainer,
  Subtitle,
  PortionContainer,
  SkeletonWrapper,
} from './styles';

import { FiFileText } from 'react-icons/fi';
import { BiCalendar } from 'react-icons/bi';
import { FaFileInvoiceDollar } from 'react-icons/fa';
import GoBackPage from '../../components/GoBackPage';
import { useHistory, useLocation } from 'react-router-dom';
import { getAgreementPortionDebt } from '../../store/agreement/actions';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import ModalContracts from '../../components/Modal/Contracts';
import CleanBase from '../CleanBase';
import formatPrice from '../../services/utils/formatPrice';
import { navigationUrl } from '../../store/analytic/actions';
import Skeleton from 'react-loading-skeleton';
import {
  confirmNegotiation,
  getDealState,
} from '../../store/negotiation/actions';
import { getContractsFromDealOrDebt } from '../../utils/getContractsToShow';
import getContractDescription from '../../utils/getContractDescription';
import getOriginalContract from '../../utils/getOriginalContract';
import { setContractInformations } from '../../store/contract/actions';
import Toast from '../../components/Toast';
import { toast } from 'react-toastify';
import { statusNameChange } from '../Agreement/constants';

/**
 * Dicionário para exibição do portionStatus correto.
 * Os valores possíveis estão no banco de dados.
 * `select * from CAD_STPA`
 * @param portionStatus Status da parcela.
 */
const getStatus = (portionStatus: string | null): string => {
  const status = (portionStatus ?? '').trim();
  const casePaid = [
    'PAGTO. ASSESSORIA',
    'PGTO BANCO',
    'PGTO. EMBRATEL',
    'PAGTO ESCRITORIO',
    'PAGAMENTO',
    'PGTO BCO WEBSERVICE',
  ];
  if (casePaid.includes(status)) return 'Paga';
  return portionStatus as string;
};

type PortionProps = {
  agreement: GQL.IDeal;
};

const INITIAL_TEXT = 'Meu Acordo';
window.sessionStorage.setItem('selectedPortionNumber', '');

const PortionAgreement: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation<PortionProps>();
  const agreement: GQL.IDeal = location.state && location.state.agreement;
  const portions: GQL.IPortion[] = useSelector(
    (state: ApplicationState) => state.agreement.portions
  );
  const { agreementPortionDebt } = useSelector((state: ApplicationState) => ({
    agreementPortionDebt: state.agreement.agreementPortionDebt,
  }));
  const [open, setOpen] = useState(false);
  const dealState = useSelector(
    (state: ApplicationState) => state.negotiation.dealState
  );

  const status = useSelector(
    (state: ApplicationState) => state.agreement.status
  );
  const [detail, setDetail] = useState({});

  const contractsToShow = useMemo(() => getContractsFromDealOrDebt(agreement), [
    agreement,
  ]);

  useEffect(() => {
    if (agreement) {
      dispatch(
        getAgreementPortionDebt.request({
          dealId: agreement.dealId,
          databaseId: agreement.databaseId,
        })
      );

      dispatch(
        navigationUrl.request({
          action: '/parcelasAcordo',
          creditor: agreement.creditorName,
          dealValue: agreement.totalPlanValue,
          plan: agreement.plan,
        })
      );
    } else {
      history.push('/acordos');
    }
  }, [dispatch, history, agreement]);

  useEffect(() => {
    dispatch(confirmNegotiation.failure(null));
  }, [dispatch]);

  useEffect(() => {
    if (dealState && dealState?.length > 0) {
      if (dealState[0].statusDescription === 'Aprovado') {
        dispatch(
          setContractInformations({
            databaseId: agreement.databaseId,
            creditorId: agreement.creditorId,
          })
        );
        history.push({
          pathname: '/opcoes',
          state: {
            contractDeal: agreement,
            proposal: portions,
            type: 'acordo',
            detail,
          },
        });
      } else {
        if (status === 'PROM. CANCELADA'.trim()) {
          dispatch(
            setContractInformations({
              databaseId: agreement.databaseId,
              creditorId: agreement.creditorId,
            })
          );
          history.push({
            pathname: '/opcoes',
            state: {
              contractDeal: agreement,
              proposal: portions,
              type: 'acordo',
              detail,
            },
          });
        } else if (status === 'PROM CREDOR CANC.'.trim()) {
          history.push({
            pathname: '/métodos-pagamento',
            state: { contract: agreement },
          });
        } else {
          history.push({
            pathname: '/negociacao-status',
            state: {
              from: 'deal',
              contract: {
                contracts: agreement.contracts,
                creditorName: agreement.creditorName,
                updatedValue: agreement.totalPlanValue,
              },
              negotiation: {
                formatedDueDate: moment(agreement.portionDueDate).format(
                  'DD/MM/YYYY'
                ),
                plan: agreement.plan,
              },
              status:
                dealState && dealState.length > 0
                  ? dealState[0].statusDescription
                  : '',
            },
          });
        }
      }
    }
  }, [dispatch, dealState, history, agreement, status, portions, detail]);

  const handlerContracts = (): void => {
    setOpen(true);
  };

  const handlerClose = (): void => {
    setOpen(false);
  };

  const handlerOptions = (portion: GQL.IPortion): void => {
    setDetail({
      portion: `${portion.portionNumber}/${agreement.plan}`,
      value: formatPrice(portion.portionValue ?? 0),
      date: moment(portion.portionDueDate).format('DD/MM/YYYY'),
    });

    if (portion.canEmitBillet) {
      dispatch(
        getDealState.request({
          databaseId: agreement.databaseId,
          contract: agreement.contracts,
          dealId: agreement.dealId,
        })
      );
    } else {
      toast.error(
        <Toast
          title={'Aviso'}
          description={
            'Não é possível emitir o boleto dessa parcela nesse momento.'
          }
        />
      );
    }

    const portionNumber: string =
      portion && portion.portionNumber ? portion.portionNumber.toString() : '';
    window.sessionStorage.setItem('selectedPortionNumber', portionNumber);
  };

  return (
    <>
      {agreementPortionDebt ? (
        <Wrapper>
          <SkeletonWrapper>
            <Skeleton className='navbar' />
            <Skeleton className='info' />
            <Skeleton className='title-option' />
            <Skeleton className='option' />
          </SkeletonWrapper>
        </Wrapper>
      ) : (
        <>
          {portions.length > 0 ? (
            <Wrapper>
              <Container>
                <Line>
                  <Title>{INITIAL_TEXT}</Title>
                  <BreadCrumb>
                    <span
                      id='link'
                      onClick={() => history.replace('/contrato')}
                    >
                      Débitos e Acordos
                    </span>

                    <span id='bar'> / </span>
                    <span>{INITIAL_TEXT}</span>
                  </BreadCrumb>
                  <Back>
                    <GoBackPage text={INITIAL_TEXT} />
                  </Back>
                </Line>

                <InfoContainer>
                  <h2>
                    Valor do acordo: R${' '}
                    {agreement && formatPrice(agreement.totalPlanValue)}
                  </h2>
                  <p>{agreement && agreement.creditorName}</p>
                  <p>
                    <strong> {statusNameChange[status] ?? status}</strong>
                  </p>
                  <div className='options'>
                    <FiFileText className='space-right' />
                    {agreement?.contracts?.length > 1
                      ? 'Múltiplos contratos: '
                      : 'Contrato: '}
                    {agreement?.contracts?.length === 1 && (
                      <strong>
                        {agreement && getOriginalContract(contractsToShow[0])}
                      </strong>
                    )}
                    {agreement &&
                      agreement.contracts &&
                      agreement.contracts.length > 1 && (
                        <a onClick={handlerContracts}>Clique para exibir</a>
                      )}
                  </div>
                  <div className='options'>
                    <FaFileInvoiceDollar
                      id='icon'
                      style={{ height: 14, marginRight: 4 }}
                    />
                    Parcela atual ({agreement.portion}/{agreement.plan}):{' '}
                    <strong>
                      R$ {agreement && formatPrice(agreement.portionValue ?? 0)}
                    </strong>
                  </div>
                  <div className='options'>
                    <BiCalendar className='space-right' />
                    Vencimento da entrada:{' '}
                    <span className='date'>
                      {moment(agreement && agreement.portionDueDate).format(
                        'DD/MM/YYYY'
                      )}
                    </span>
                  </div>
                  {agreement && agreement.contracts.length === 1 && (
                    <span
                      className='options'
                      style={{ marginBottom: 0, wordBreak: 'break-word' }}
                    >
                      {getContractDescription(contractsToShow[0])}
                    </span>
                  )}
                </InfoContainer>

                <Subtitle>parcelas do acordo</Subtitle>
                {portions.map((portion, index) => (
                  <PortionContainer
                    key={index}
                    status={portion.portionStatus ?? ''}
                    canEmitBillet={portion.canEmitBillet ?? false}
                    onClick={() =>
                      portion.portionStatus === 'Pago'
                        ? null
                        : handlerOptions(portion)
                    }
                  >
                    <div className='item'>
                      <p className='text'>
                        Parcela {portion.portionNumber}/
                        {agreement && agreement.plan}
                      </p>
                      <p className='value'>
                        R$ {formatPrice(portion.portionValue ?? 0)}
                      </p>
                      <p className='date'>
                        <BiCalendar style={{ marginRight: 4 }} />
                        <span>
                          Vencimento:{' '}
                          <strong>
                            {moment(portion.portionDueDate).format(
                              'DD/MM/YYYY'
                            )}
                          </strong>
                        </span>
                      </p>
                    </div>
                    <div className='status'>
                      {getStatus(portion.portionStatus)}
                    </div>
                  </PortionContainer>
                ))}
              </Container>
              {open && (
                <ModalContracts
                  handlerClose={handlerClose}
                  contracts={contractsToShow}
                />
              )}
            </Wrapper>
          ) : (
            <CleanBase type='acordo' />
          )}
        </>
      )}
    </>
  );
};

export default PortionAgreement;
